// Renders post content in the public reader.
// - New posts from the TipTap editor are stored as HTML (start with "<")
//   and rendered via dangerouslySetInnerHTML on a `prose-law` block.
// - Legacy posts are stored as markdown-lite (## headings, blank lines,
//   "- " bullet lists) and rendered by parsing block-by-block.
// Admin content is authored by the firm; no third-party input flows here,
// so sanitization is intentionally omitted. Revisit if authorship widens.

function isHtml(content) {
  if (!content) return false;
  const trimmed = content.trimStart();
  return trimmed.startsWith("<");
}

function LegacyMarkdown({ content }) {
  const blocks = content.split(/\n\n+/);
  return (
    <>
      {blocks.map((b, i) => {
        if (b.startsWith("## ")) return <h2 key={i}>{b.replace(/^##\s+/, "")}</h2>;
        if (b.startsWith("### ")) return <h3 key={i}>{b.replace(/^###\s+/, "")}</h3>;
        if (b.split("\n").every((l) => l.trim().startsWith("- "))) {
          return (
            <ul key={i}>
              {b.split("\n").map((l, j) => (
                <li key={j}>{l.replace(/^-\s+/, "")}</li>
              ))}
            </ul>
          );
        }
        return <p key={i}>{b}</p>;
      })}
    </>
  );
}

export default function PostContent({ content }) {
  if (!content) return null;
  if (isHtml(content)) {
    return <div dangerouslySetInnerHTML={{ __html: content }} />;
  }
  return <LegacyMarkdown content={content} />;
}
